module.exports = __webpack_public_path__ + "img/news2-3.6325e555.png";